import Immutable from 'immutable';

export interface ModalStateData {
  id: string;
  portal: string;
  component: React.ReactNode | null;
  props: Record<string, unknown>;
  open: boolean;
  className: string;
  overlayClassName: string;
  shouldCloseOnOverlayClick: boolean;
  shouldCloseOnEsc: boolean;
}

export type ModalStateList = Immutable.List<ModalState>;

const defaultValues: ModalStateData = {
  id: '',
  portal: 'main',
  component: null,
  props: {},
  open: false,
  className: '',
  overlayClassName: '',
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true,
};

export const ModalStateFactory = Immutable.Record(defaultValues, 'ModalState');

export class ModalState extends ModalStateFactory {}
